import { Component, inject, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { AdaaHelper } from "../../../core/utils";
import { DataTableComponent } from "../../../shared/components";
import { genericFloatButtons } from "../../../shared/components/general/float-action";
import { Constants } from "../../../shared/constants/constants";
import { TableButtonClicked } from "../../../shared/models";
import { SystemLayoutService } from "../../../shared/services";

@Component({
  selector: "adaa-lookup-management-list",
  imports: [DataTableComponent, TranslatePipe],
  templateUrl: "./lookup-management-list.html",
  styleUrl: "./lookup-management-list.scss",
})
export class LookupManagementListComponent {
  private _router = inject(Router);
  private _systemLayoutService = inject(SystemLayoutService);

  adaaDataTable = viewChild.required<DataTableComponent>("adaaDataTable");
  constants = Constants;
  readonly #floatActions = genericFloatButtons();

  public ngOnInit(): void {
    this.#floatActions([
      {
        key: "print",
        data: undefined,
      },
    ]);

    this._systemLayoutService.hasActiveEntityChanged$.subscribe(() => {
      !AdaaHelper.isPMOEntity() && this._router.navigateByUrl("/console");
    });
  }

  public getAction(event: TableButtonClicked) {
    const lookupId = event.data.id;
    switch (event.event) {
      case "edit":
        this._router.navigateByUrl(`/console/lookup/${lookupId}`);
        break;

      default:
        break;
    }
  }
}
